<template>
  <div class="col backgroundForm">
    <div class="col-md-6 offset-md-3">
        <div class="alert alert-info" align="center" role="alert">
            <h4 class="alert-heading">Registro de Puertos y Muelles</h4>
            <p>Realiza la insercion, administracion de puertos y muelles </p>       
        </div>
    </div>

    <nav>
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
            <a class="nav-item nav-link active" id="nav-init-list" data-toggle="tab" href="#nav-ports" role="tab" aria-controls="nav-home" aria-selected="true"> Puertos</a>
            <a class="nav-item nav-link" id="nav-second-register" data-toggle="tab" href="#nav-muelles" role="tab" aria-controls="nav-detail" aria-selected="false"> Muelles</a>
        </div>
    </nav>
    <div class="tab-content" id="nav-tabContent">
                
          <div class="tab-pane fade show active" id="nav-ports" role="tabpanel" aria-labelledby="nav-home-tab">
              <br><div class="alert alert-info col col-md-8 offset-md-2">
                Registro y Listado de Puertos
              </div>
            
              <div class="row">
                <div class="form-group col-12 col-md-4">
                    <label for="type_identification" class="badge badge-primary">Cuenca</label>
                    <select name="cuenca" id="cuenca_port" class="form-control" v-model="port_register.cuenca">
                        <option v-for="ca in cuencas" :key="ca.id" :value="ca.id">{{ca.detail}}</option>
                    </select>
                </div>

                <div class="form-group col-12 col-md-4">
                    <label for="type_identification" class="badge badge-primary">Nombre Puerto</label>
                    <input type="text" name="name_owner" id="name_owner" class="form-control" v-model="port_register.name" required autocomplete="off">
                </div>

                <div class="form-group col-12 col-md-4">
                    <label for="number_identification" class="badge badge-primary">Abreviatura Puerto </label>
                    <input type="text" class="form-control" v-model="port_register.short_name" name="number_identification" required autocomplete="off">
                </div>

              </div>
              <button class="btn btn-success col-md-4 offset-md-4" @click="mRegisterPort"> <font-awesome-icon icon="save" /> Registrar</button>
              <br><br>
              <button class="btn btn-warning col-md-4 offset-md-4" @click="mListPortsRegister('all')"><font-awesome-icon icon="list" /> Listar</button>

              <div class="table-responsive" v-if="ports_registers.length>0">
                <table class="table">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Puerto</th>
                            <th>Abreviatura</th>
                            <th>Cuenca</th>
                            <th>Estado</th>
                            <th>Edicion</th>
                            <th>Cambio</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(pr, index) in ports_registers" :key="pr.id">
                            <td>{{ index+1 }}</td>
                            <td>
                                <span v-if="pr.edicion==='N'">{{ pr.detalle_puerto }}</span>
                                <input v-else type="text" class="form-control" autocomplete="off" name="temp_id_name" id="temp_name" v-model="temp_port_edit.detalle_puerto">
                            </td>
                            <td>
                                <span v-if="pr.edicion==='N'">{{ pr.abreviatura_puerto }}</span>
                                <input v-else type="text" class="form-control" autocomplete="off" name="temp_id_abreviado" id="temp_abreviatura" v-model="temp_port_edit.abreviatura_puerto">
                            </td>
                            <td>
                                <span v-if="pr.edicion==='N'">{{ pr.cuenca_detalle }}</span>
                                <select name="detail" id="detail" class="form-control" v-model="temp_port_edit.cuenca" v-else>
                                    <option v-for="lcu in cuencas" :key="lcu.id" :value="lcu.id">{{lcu.detail }}</option>
                                </select>
                            </td>
                            <td>
                                <span class="alert alert-success" v-if="pr.estado_puerto==='A'">Activo</span>
                                <span class="alert alert-danger" v-if="pr.estado_puerto==='I'">Inactivo</span>
                            </td>
                            <td>
                                <div v-if="pr.edicion==='N'">
                                    <button class="btn btn-warning" @click="mEditPortRegister(pr)"><font-awesome-icon icon="edit"  /></button>
                                </div>
                                <div v-else>
                                    <button class="btn btn-success"  @click="mUpdatePort"><font-awesome-icon icon="sync-alt" /></button>
                                    <button class="btn btn-danger" @click="mCancelEditPort"><font-awesome-icon icon="times-circle" /></button>
                                </div>
                            </td>
                            <td>
                                <button class="btn btn-success" v-if="pr.estado_puerto==='A'" @click="mChangeState(pr.id)"><font-awesome-icon icon="toggle-on" /></button>
                                <button class="btn btn-danger" @click="mChangeState(pr.id)" v-else><font-awesome-icon icon="toggle-off" /></button>
                            </td>
                        </tr>
                    </tbody>
                </table>
              </div>

          </div>

          <div class="tab-pane fade" id="nav-muelles" role="tabpanel" aria-labelledby="nav-home-tab">
              <br><div class="alert alert-info col col-md-8 offset-md-2">
                Registro y Listado de Muelles
              </div>
              
              <div class="row">

                
                <div class="col-md-4 mb-3">
                    <label for="validationDefaultUsername">Puerto</label>
                    <div class="input-group">
                        <select name="puerto_muelle" id="puerto_muelle" class="form-control" v-model="muelle.puerto" aria-placeholder="Seleccione una Opcion">
                            <option v-for="pra in ports_registers_active" :key="pra.id" :value="pra.id">{{pra.detalle_puerto}} - {{pra.cuenca_detalle}}</option>
                        </select>
                        <div class="input-group-prepend">
                            <button class="btn btn-success" @click="mListPortsRegister('active')"><font-awesome-icon icon="sync-alt" /></button>
                        </div>
                    </div>
                </div>

                <div class="form-group col-12 col-md-4">
                    <label for="type_identification" class="badge badge-primary">Nombre Muelle</label>
                    <input type="text" name="name_muelle" id="name_muelle" class="form-control" v-model="muelle.name" placeholder="Muelle XY" required autocomplete="off">
                </div>

                <div class="form-group col-12 col-md-4">
                    <label for="abreviatura_muelle" class="badge badge-primary">Abreviatura Muelle </label>
                    <input type="text" class="form-control" v-model="muelle.short_name" name="abreviatura_muelle" placeholder="MU" required autocomplete="off">
                </div>

              </div>
              <div class="form-row">
                <div class="form-group col">
                    <label for="number_identification" class="badge badge-primary">Descripcion Muelle </label>
                    <textarea name="descripcion_muelle" id="descripcion_muelle" class="form-control" cols="30" rows="3" placeholder="Descripcion del Muelle"></textarea>
                </div>
              </div>
              <button class="btn btn-success col-md-4 offset-md-4" @click="mRegisterMuelle"> <font-awesome-icon icon="save" /> Registrar Muelle</button>
              <br><br>
              <button class="btn btn-warning col-md-4 offset-md-4" @click="mListMuelleRegister('all')"><font-awesome-icon icon="list" /> Listar Muelles</button>

              <div class="table-responsive" v-if="muelle_registers.length>0">
                <table class="table">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Cuenca</th>
                            <th>Puerto</th>
                            <th>Muelle</th>
                            <th>Abreviatura</th>
                            <th>Estado</th>
                            <th>Edicion</th>
                            <th>Cambio</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(mr, index) in muelle_registers" :key="mr.id">
                            <td>{{ index+1 }}</td>
                            <td>
                                {{ mr.cuenca_detalle }}
                            </td>
                            <td>
                                <span v-if="mr.edicion==='N'">{{ mr.detalle_puerto }}</span>
                                <select name="puerto_muelle" id="puerto_muelle" class="form-control" v-model="temp_muelle_edit.id_puerto" aria-placeholder="Seleccione una Opcion" v-else>
                                    <option v-for="lprt in ports_registers_active" :key="lprt.id" :value="lprt.id">{{lprt.detalle_puerto}} - {{lprt.cuenca_detalle}}</option>
                                </select>
                            </td>
                            <td>
                                <span v-if="mr.edicion==='N'">{{ mr.nombre_muelle }}</span>
                                <input v-else type="text" class="form-control" autocomplete="off" name="temp_id_abreviado" id="temp_abreviatura" v-model="temp_muelle_edit.nombre_muelle">
                            </td>
                            <td>
                                <span v-if="mr.edicion==='N'">{{ mr.abreviatura_muelle }}</span>
                                <input v-else type="text" class="form-control" autocomplete="off" name="temp_id_abreviado" id="temp_abreviatura" v-model="temp_muelle_edit.abreviatura_muelle">
                            </td>
                            <td>
                                <span class="alert alert-success" v-if="mr.estado_muelle==='A'">Activo</span>
                                <span class="alert alert-danger" v-if="mr.estado_muelle==='I'">Inactivo</span>
                            </td>
                            <td>
                                <div v-if="mr.edicion==='N'">
                                    <button class="btn btn-warning" @click="mEditMuelleRegister(mr)"><font-awesome-icon icon="edit"  /></button>
                                </div>
                                <div v-else>
                                    <button class="btn btn-success"  @click="mUpdateMuelle"><font-awesome-icon icon="sync-alt" /></button>
                                    <button class="btn btn-danger" @click="mCancelEditMuelle"><font-awesome-icon icon="times-circle" /></button>
                                </div>
                            </td>
                            <td>
                                <button class="btn btn-success" v-if="mr.estado_muelle==='A'" @click="mChangeStateMuelle(mr.id)"><font-awesome-icon icon="toggle-on" /></button>
                                <button class="btn btn-danger" @click="mChangeStateMuelle(mr.id)" v-else><font-awesome-icon icon="toggle-off" /></button>
                            </td>
                        </tr>
                    </tbody>
                </table>
              </div>


          </div>
    </div>

    <!-- end div background -->
  </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
const qs = require('qs');



export default {
    name: "register-port",
    data() {
        return {
            muelle:{
                puerto:0,
                name:'',
                short_name:'',
                description:''
            },
            port_register: {
                cuenca: 0,
                name: "",
                short_name: ""
            },
            cuencas: [],
            ports_registers: [],
            ports_registers_active:[],
            temp_port_edit: {
                id: 0,
                cuenca: 0,
                detalle_puerto: "",
                abreviatura_puerto: "",
                estado_puerto:''
            },
            temp_muelle_edit: {
                id: 0,
                cuenca: 0,
                id_puerto: 0,
                nombre_muelle:'',
                abreviatura_muelle: "",
                estado_puerto:''
            },
            muelle_registers:[],
            muelle_registers_active:[]
        };
    },
    mounted() {
        this.mCallCharge();
    },
    methods: {
        async mChangeStateMuelle(id){
            let idxpr=this.muelle_registers.findIndex(idb=> idb.id===id);
            let state=this.muelle_registers[idxpr].estado_muelle;
            let new_state;
            if(state==='A'){
                new_state='I';
            }else{
                new_state='A';
            }
            this.muelle_registers[idxpr].estado_muelle=new_state;
            let nstate={
                id:id,
                estado:new_state
            }
            let u_dts_muelle = await axios.post(`updateMuelle/state?api_token=${Vue.auth.getToken()}`, qs.stringify(nstate));

            toastr.success(u_dts_muelle.data.respuesta);

        },
        async mUpdateMuelle(){
            // console.log('actualizando el registro');
            let ide=this.muelle_registers.findIndex(elb=> elb.id===this.temp_muelle_edit.id);
            
            this.muelle_registers[ide].id=this.temp_muelle_edit.id;
            this.muelle_registers[ide].abreviatura_muelle=this.temp_muelle_edit.abreviatura_muelle;
            // this.muelle_registers[ide].estado_puerto=this.temp_muelle_edit.estado_puerto;
            this.muelle_registers[ide].edicion='N';

            let u_dts_port = await axios.post(`updateMuelle/all?api_token=${Vue.auth.getToken()}`, qs.stringify(this.temp_muelle_edit));
            toastr.success(u_dts_port.data.respuesta);
            this.mListMuelleRegister('all');
        },
        mCancelEditMuelle(){
            let idb=this.muelle_registers.findIndex(dt=> dt.edicion==='S');
            if(idb>-1){
                this.muelle_registers[idb].edicion='N';
            }
            this.temp_muelle_edit.id=0;
            this.temp_muelle_edit.id_puerto=0;
            this.temp_muelle_edit.abreviatura_puerto='';
            this.temp_muelle_edit.estado_puerto='';
        },
        mEditMuelleRegister(el){
            // console.log('llegando a la edicion')
            let idb=this.muelle_registers.findIndex(dt=> dt.edicion==='S');
            if(idb>-1){
                this.muelle_registers[idb].edicion='N';
            }
            let ide=this.muelle_registers.findIndex(elb=> elb.id===el.id);
            this.muelle_registers[ide].edicion='S';

            this.temp_muelle_edit.id=el.id;
            this.temp_muelle_edit.id_puerto=el.id_puerto;
            this.temp_muelle_edit.nombre_muelle=el.nombre_muelle;
            this.temp_muelle_edit.abreviatura_muelle=el.abreviatura_muelle;
        },
        mValidateFormMuelle(){
            if (this.muelle.puerto === 0) {
                toastr.warning(`Seleccione el puerto al cual pertenece`, "Error");
                return false;
            }
            this.muelle.name = this.muelle.name.trim();
            if (this.muelle.name.length === 0) {
                toastr.warning(`Indique el nombre del Muelle`, "Error");
                return false;
            }
            return true;
        },
        mRegisterMuelle(){
            let message = {
                title: "Registro de Puerto",
                body: `¿Desea registrar el Muelle de nombre <b>${this.muelle.name}</b>?`
            };
            // validar que los datos esten completos
            if (this.mValidateFormMuelle()) {
                let npr = new Promise((resolve, reject) => {
                    this.$dialog
                        .confirm(message)
                        .then(function (dialog) {
                        resolve(true);
                    })
                        .catch(function () {
                        resolve(false);
                    });
                });
                npr.then(async (msg) => {
                    if (msg) {
                        // registramos y validamos el presupuesto general en la bd
                        try {
                            let r_dts_muelle = await axios.post(`registerMuelle?api_token=${Vue.auth.getToken()}`, qs.stringify(this.muelle));
                            // console.log(r_dts_muelle);
                            if (r_dts_muelle.data.status) {
                                toastr.success(`${r_dts_muelle.data.respuesta}`);
                                this.muelle.name = "";
                                this.muelle.short_name = "";
                                this.muelle.description = "";
                            }
                            else {
                                toastr.danger("Ha ocurrido un error al Registrar el Muelle");
                            }
                        }
                        catch (error) {
                            console.log(error);
                        }
                    }
                    else {
                    }
                });
            }
        },
        async mChangeState(id){
            let idxpr=this.ports_registers.findIndex(idb=> idb.id===id);
            let state=this.ports_registers[idxpr].estado_puerto;
            let new_state;
            if(state==='A'){
                new_state='I';
            }else{
                new_state='A';
            }
            this.ports_registers[idxpr].estado_puerto=new_state;
            let nstate={
                id:id,
                estado_puerto:new_state
            }
            let u_dts_port = await axios.post(`updatePort/state?api_token=${Vue.auth.getToken()}`, qs.stringify(nstate));

            toastr.success(u_dts_port.data.respuesta);

        },
        async mUpdatePort(){
            console.log('actualizando el registro');
            let ide=this.ports_registers.findIndex(elb=> elb.id===this.temp_port_edit.id);
            
            this.ports_registers[ide].id=this.temp_port_edit.id;
            this.ports_registers[ide].cuenca=this.temp_port_edit.cuenca;
            this.ports_registers[ide].detalle_puerto= this.temp_port_edit.detalle_puerto;
            this.ports_registers[ide].abreviatura_puerto=this.temp_port_edit.abreviatura_puerto;
            this.ports_registers[ide].estado_puerto=this.temp_port_edit.estado_puerto;
            this.ports_registers[ide].edicion='N';

            let u_dts_port = await axios.post(`updatePort/all?api_token=${Vue.auth.getToken()}`, qs.stringify(this.temp_port_edit));
            toastr.success(u_dts_port.data.respuesta);
            this.mListPortsRegister('all');
        },
        mEditPortRegister(el){
            // console.log('llegando a la edicion')
            let idb=this.ports_registers.findIndex(dt=> dt.edicion==='S');
            if(idb>-1){
                this.ports_registers[idb].edicion='N';
            }
            let ide=this.ports_registers.findIndex(elb=> elb.id===el.id);
            this.ports_registers[ide].edicion='S';

            this.temp_port_edit.id=el.id;
            this.temp_port_edit.cuenca=el.cuenca;
            this.temp_port_edit.detalle_puerto=el.detalle_puerto;
            this.temp_port_edit.abreviatura_puerto=el.abreviatura_puerto;
            this.temp_port_edit.estado_puerto=el.estado_puerto;
        },
        mCancelEditPort(){
            let idb=this.ports_registers.findIndex(dt=> dt.edicion==='S');
            if(idb>-1){
                this.ports_registers[idb].edicion='N';
            }
            this.temp_port_edit.id=0;
            this.temp_port_edit.cuenca=0;
            this.temp_port_edit.detalle_puerto='';
            this.temp_port_edit.abreviatura_puerto='';
            this.temp_port_edit.estado_puerto='';
        },
        async mCallCharge() {
            let cuenca_aux = await axios.get(`globals/basin?api_token=${Vue.auth.getToken()}`);
            this.cuencas = cuenca_aux.data;
            this.mListPortsRegister('active');
        },
        mValidateFormPort() {
            if (this.port_register.cuenca === 0) {
                toastr.warning(`Seleccione la cuenca a la cual pertenece`, "Error");
                return false;
            }
            this.port_register.name = this.port_register.name.trim();
            // console.log(this.port_register.name);
            if (this.port_register.name.length === 0) {
                toastr.warning(`Indique el nombre de Puerto`, "Error");
                return false;
            }
            return true;
        },
        mRegisterPort() {
            let message = {
                title: "Registro de Puerto",
                body: `¿Desea registrar el Puerto de nombre <b>${this.port_register.name}</b>?`
            };
            // validar que los datos esten completos
            if (this.mValidateFormPort()) {
                let npr = new Promise((resolve, reject) => {
                    this.$dialog
                        .confirm(message)
                        .then(function (dialog) {
                        resolve(true);
                    })
                        .catch(function () {
                        resolve(false);
                    });
                });
                npr.then(async (msg) => {
                    if (msg) {
                        // registramos y validamos el presupuesto general en la bd
                        try {
                            // let btn_send=document.getElementById(this.btn_r_ordop);
                            // aqui enviamos al servidor para registrar
                            // console.log("enviando");
                            let r_dts_port = await axios.post(`registerPort?api_token=${Vue.auth.getToken()}`, qs.stringify(this.port_register));
                            // console.log(r_dts_port);
                            if (r_dts_port.data.status) {
                                toastr.success(`${r_dts_port.data.respuesta}`);
                                this.port_register.name = "";
                                this.port_register.short_name = "";
                            }
                            else {
                                toastr.danger("Ha ocurrido un error al Registrar el Puerto");
                            }
                        }
                        catch (error) {
                            console.log(error);
                        }
                    }
                    else {
                    }
                });
            }
        },
        async mListPortsRegister(tb = "all") {
            this.ports_registers = [];
            this.ports_registers_active=[];
            let port_aux;
            if(tb==='all'){
                port_aux = await axios.get(`getPortsRegisters/${tb}?api_token=${Vue.auth.getToken()}`);
            }
            if(tb==='active'){
                port_aux = await axios.get(`getPortsRegisters/${tb}?api_token=${Vue.auth.getToken()}`);
            }
            
            if (port_aux.data.length > 0) {
                port_aux.data.forEach((dtp) => {
                    let aux_p = {
                        id: dtp.id,
                        detalle_puerto: dtp.detalle_puerto,
                        abreviatura_puerto: dtp.abreviatura_puerto,
                        cuenca: dtp.cuenca,
                        cuenca_detalle: dtp.cuenca_detalle,
                        estado_puerto: dtp.estado_puerto,
                        edicion: 'N'
                    };
                    if(tb==='all'){
                        this.ports_registers.push(aux_p);
                    }
                    if(tb==='active'){
                        this.ports_registers_active.push(aux_p);
                    }
                });
                // this.ports_registers=port_aux.data;
            }
        },
        async mListMuelleRegister(tb = "all") {
            this.muelle_registers = [];
            this.muelle_registers_active=[];
            let muelle_aux;
            if(tb==='all'){
                muelle_aux = await axios.get(`getMuellesRegisters/${tb}?api_token=${Vue.auth.getToken()}`);
            }
            if(tb==='active'){
                muelle_aux = await axios.get(`getMuellesRegisters/${tb}?api_token=${Vue.auth.getToken()}`);
            }
            
            if (muelle_aux.data.length > 0) {
                muelle_aux.data.forEach((dtp) => {
                    let aux_p = {
                        id: dtp.id,
                        detalle_puerto: dtp.detalle_puerto,
                        nombre_muelle: dtp.nombre_muelle,
                        abreviatura_muelle: dtp.abreviatura_muelle,
                        cuenca: dtp.cuenca,
                        cuenca_detalle: dtp.cuenca_detalle,
                        estado_muelle: dtp.estado_muelle,
                        id_puerto: dtp.id_puerto,
                        edicion: 'N'
                    };
                    if(tb==='all'){
                        this.muelle_registers.push(aux_p);
                    }
                    if(tb==='active'){
                        this.muelle_registers_active.push(aux_p);
                    }
                });
                // this.ports_registers=port_aux.data;
            }
        }
    },
    components: { FontAwesomeIcon }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/uumm/RegisterPort.vue